module.exports = __webpack_public_path__ + "img/KeeperOfTheLight.8fcc3f87.png";